import { render, staticRenderFns } from "./CreateOriginalSample.vue?vue&type=template&id=2250bbaf&scoped=true&"
import script from "./CreateOriginalSample.vue?vue&type=script&lang=js&"
export * from "./CreateOriginalSample.vue?vue&type=script&lang=js&"
import style0 from "./CreateOriginalSample.vue?vue&type=style&index=0&id=2250bbaf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2250bbaf",
  null
  
)

export default component.exports